module.exports = lib_ui__rc_editor_mention;